import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16 flex items-center justify-center min-h-[70vh]">
        <div className="text-center px-4">
          <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6">
            <i className="ri-movie-2-line text-6xl text-accent-500/50"></i>
          </div>
          <h1 className="text-5xl md:text-6xl font-heading text-foreground-950 mb-3">404</h1>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            抱歉，您要找的页面走丢了~ 不如去看部免费电影放松一下？
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-sm"></i>
            </span>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}